import { useLazyQuery, useQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import { SwitchInput } from '../../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../../components/textInput/TextInput';

import { GET_INSTITUCIONES_BY_PACIENTE } from '../../../../data/graphQL/queries/ResumenIngreso/getInstitucionesByPaciente';
import { adaptCentroReferenciaArray } from '../../../../adapters/resumenIngreso/centroReferenciaAdapter';
import { SearchInput } from './components/SearchInput';
import { useDebounce } from '../../../../hooks/useDebounce';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { adaptLugarServicioArray, GET_ALL_LUGAR_SERVICIO } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getLugarServicio';
import { ES_NUTRICIONISTA } from '../../../../data/graphQL/queries/ResumenIngreso/isTipoProfesionalNutricionista';
import { adaptProgramasPermitidosArray, GET_PROGRAMAS_PERMITIDOS_BY_USER } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getProgramasPermitidosByUsuario';

const centroColumns = [
  {
    field: 'cod_institucion',
    headerName: 'Código',
    flex: 0.3
  },
  {
    field: 'nombre',
    headerName: 'Centro de Referencia',
    flex: 0.7
  }];


export const StepDatosGenerales1 = ({
  selectedPrograms,
  handleChangePrograms,
  datosFiliatorios,
  idPaciente,
  modulosOptions,
  setLugarServicioRIEsDomicilio,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  edit,
  direccionRI
}) => {
  const [centroReferencia, setCentroReferencia] = useState(fullFormDataRI?.datosGenerales1?.centroReferencia ?? false);
  const [codInstitucionReferencia, setCodInstitucionReferencia] = useState(fullFormDataRI?.datosGenerales1?.codInstitucionReferencia);
  const [idComboRIValorLugarRI, setIdComboRIValorLugarRI] = useState(fullFormDataRI?.datosGenerales1?.idComboRIValorLugarRI);
  const [idComboRIValorLugarServicio, setIdComboRIValorLugarServicio] = useState(fullFormDataRI?.datosGenerales1?.idComboRIValorLugarServcio);
  const [servicioEmergencia, setServicioEmergencia] = useState(fullFormDataRI?.datosGenerales1?.servicioEmergencia);
  const [telefonoEmergencia, setTelefonoEmergencia] = useState(fullFormDataRI?.datosGenerales1?.telefonoEmergencia);

  const [
    centrosRows,
    setPaginationStatus,
    paginationStatus,
    centrosTotalCount,
    filterStatus,
    setFilterStatus] =
    useGetCentros(idPaciente, codInstitucionReferencia);

  const { data: esNutricionistaData } = useQuery(ES_NUTRICIONISTA);

  const isNutricionista = useMemo(() => {
    return esNutricionistaData?.isTipoProfesionalNutricionista;
  }, [esNutricionistaData]);

  useEffect(() => {
    setCentroReferencia(fullFormDataRI.datosGenerales1?.centroReferencia);
    setCodInstitucionReferencia(fullFormDataRI.datosGenerales1?.codInstitucionReferencia);
    setIdComboRIValorLugarRI(fullFormDataRI.datosGenerales1?.idComboRIValorLugarRI);
    setIdComboRIValorLugarServicio(fullFormDataRI.datosGenerales1?.idComboRIValorLugarServicio);
    setServicioEmergencia(fullFormDataRI.datosGenerales1?.servicioEmergencia);
    setTelefonoEmergencia(fullFormDataRI.datosGenerales1?.telefonoEmergencia);
  }, [fullFormDataRI?.datosGenerales1]);

  const [lugarOptions, setLugarOptions] = useState([]);
  const [programasPermitidos, setProgramasPermitidos] = useState([]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [
    centroReferencia,
    idComboRIValorLugarRI,
    idComboRIValorLugarServicio,
    servicioEmergencia,
    telefonoEmergencia,
    codInstitucionReferencia,
    selectedPrograms,
    setDataSubmissionCallback]
  );

  const domicilioId = useMemo(() => lugarOptions.find((x) => x.displayName.includes('Domicilio'))?.id, [lugarOptions]);

  useEffect(() => {
    setLugarServicioRIEsDomicilio(domicilioId === idComboRIValorLugarServicio);
  }, [idComboRIValorLugarServicio, domicilioId]);

  const handleSubmit = () => {
    updateFormData('datosGenerales1', {
      tiposModulos: selectedPrograms,
      centroReferencia,
      codInstitucionReferencia: centroReferencia ? codInstitucionReferencia : null,
      idComboRIValorLugarServicio,
      idComboRIValorLugarRI,
      servicioEmergencia,
      telefonoEmergencia
    }, [
      {
        displayName: 'Programa Tipo',
        name: 'tiposModulos',
        required: true
      },
      {
        displayName: 'Centro de referencia',
        name: 'codInstitucionReferencia',
        required: centroReferencia
      },
      {
        displayName: 'Lugar de RI',
        name: 'idComboRIValorLugarRI',
        required: true
      },
      {
        displayName: 'Lugar donde se prestara el servicio',
        name: 'idComboRIValorLugarServicio',
        required: true
      }]
    );
  };

  const { data: lugarOptionsData } = useQuery(GET_ALL_LUGAR_SERVICIO, {
    fetchPolicy: 'no-cache',
  });

  const { data: programasPermitidosData } = useQuery(GET_PROGRAMAS_PERMITIDOS_BY_USER, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!lugarOptionsData) return;

    setLugarOptions(adaptLugarServicioArray(lugarOptionsData?.allLugarServicio));
  }, [lugarOptionsData]);

  useEffect(() => {
    if (!programasPermitidosData) return;

    setProgramasPermitidos(adaptProgramasPermitidosArray(programasPermitidosData?.programasPermitidosByUsuario));
  }, [programasPermitidosData]);

  const handleRowClick = (row) => {
    setCodInstitucionReferencia(row.row.cod_institucion);
  };

  return (
    <div>
      <SelectInput
        options={programasPermitidos}
        label='Programa Tipo'
        multiple
        required
        value={selectedPrograms}
        onChange={handleChangePrograms}
        checkMarks
        chipValue
        disabled={!edit || isNutricionista} />

      <div className='step-form-section-container'>
        <p className='step-form-section-title'>Datos filiatorios</p>
        {datosFiliatorios.map(({ key, value }) =>
          <div className='affiliation-data-row' key={key}>
            <label className='affilitaion-data-text'>{key}</label>
            <label className='affilitaion-data-text value'>{value}</label>
          </div>
        )}
        <div className='affiliation-data-row'>
          <label className='affilitaion-data-text'>Centro de referencia</label>
          <label className='affilitaion-data-text value'>
            <SwitchInput name='Centro de referencia' key={centroReferencia} checked={centroReferencia} onChange={() => setCentroReferencia(!centroReferencia)} disabled={!edit} />
          </label>
        </div>
        {centroReferencia && <SearchInput
          rows={centrosRows}
          columns={centroColumns}
          value={centrosRows.find((c) => c.cod_institucion === codInstitucionReferencia)?.nombre}
          paginationStatus={paginationStatus}
          handleChangePaginationStatus={setPaginationStatus}
          totalCount={centrosTotalCount}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          handleRowClick={handleRowClick}
          entityName='Centro de referencia*'
          description='Haz click sobre un centro para agregarlo y seguir con el formulario' />
        }
        <div className='affiliation-data-row'>
          <SelectInput
            label='Lugar donde se prestara el servicio'
            required
            options={lugarOptions}
            value={idComboRIValorLugarServicio}
            onChange={(e) => setIdComboRIValorLugarServicio(e.target.value)}
            disabled />

        </div>
        <div className='affiliation-data-row'>
          <SelectInput
            label='Lugar de RI'
            required
            options={lugarOptions}
            value={idComboRIValorLugarRI}
            onChange={(e) => setIdComboRIValorLugarRI(e.target.value)}
            disabled />

        </div>
        <div className='affiliation-data-row'>
          <label className='affilitaion-data-text'>Dirección de RI</label>
          <label className='affilitaion-data-text value'>
            {direccionRI.domicilioRI}
            {
              direccionRI.localidadRI != "" && direccionRI.provinciaRI != "" &&
              ` (${direccionRI.localidadRI}, ${direccionRI.provinciaRI} - CP: ${direccionRI.codigoPostalRI})`
            }
            {idComboRIValorLugarRI !== domicilioId &&
              direccionRI.habitacionRI != "" && ` Hab. ${direccionRI.habitacionRI}`
            }
          </label>
        </div>
        <div className='affiliation-data-row'>
          <TextInput
            label='¿Qué servicio de emergencia posee?'
            placeholder='Servicio'
            value={servicioEmergencia}
            onChange={(e) => setServicioEmergencia(e.target.value)}
            disabled={!edit} />

        </div>
        <div className='affiliation-data-row'>
          <RenderInputByTypeMobile
            handleChange={(_, value) => setTelefonoEmergencia(value.toString())}
            value={parseInt(telefonoEmergencia)}
            input={{
              displayName: 'Teléfono de emergencia',
              name: 'telefonoEmergencia',
              type: 'int'
            }} />

        </div>
      </div>
    </div>);

};

const useGetCentros = (idPaciente, codInstitucionReferencia) => {

  const [centrosDeRef, setCentrosDeRef] = useState([]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getCentros, { loading: centrosLoading, data: centrosData }] = useLazyQuery(GET_INSTITUCIONES_BY_PACIENTE, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!centrosData) return;

    setCentrosDeRef(centrosData);
  }, [centrosData]);

  useEffect(() => {
    if (!!idPaciente) {
      const orPayload = !!debouncedFilterValue ? [
        { nombre: { contains: debouncedFilterValue } },
        { cod_Institucion: { contains: debouncedFilterValue } }] :
        [];
      getCentros({
        variables: {
          idPaciente,
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
              ...orPayload,
              codInstitucionReferencia && !debouncedFilterValue ? { cod_Institucion: { eq: codInstitucionReferencia } } : {}]

          }
        }
      });
    }
  }, [
    paginationStatus,
    debouncedFilterValue,
    idPaciente,
    codInstitucionReferencia]
  );

  return [
    adaptCentroReferenciaArray(centrosDeRef) || [],
    setPaginationStatus,
    paginationStatus,
    centrosDeRef?.institucionesByPaciente?.totalCount,
    filterStatus,
    setFilterStatus];


};